// src/pages/EventPage.jsx
import React, { useState } from 'react';
import EventSlider from '../components/events/EventSlider';
import EventAllGrid from '../components/events/EventAllGrid';

export default function EventPage() {
  const [count, setCount] = useState(0);

  return (
    <div className="pt-4 bg-[#121212] min-h-screen">
      {/* 1) 맨 위에 슬라이더 */}
      <EventSlider />

      {/* 2) 타이틀 & 카운트 */}
      <div className="container mx-auto px-6 pt-8">
        <h1 className="text-2xl font-bold text-white">전체 리스트</h1>
        <p className="text-sm text-gray-400 mt-2 mb-4 ">
          총 {count}개
        </p>
      </div>

      {/* 3) 전체 그리드 */}
      <EventAllGrid onCount={setCount} />
    </div>
  );
}
